import React from 'react';
import { FormBuilder } from 'commons-ui';
import useCreate from './useCreate';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, validationSchema } from '../../helper';

const CreatePermissions: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useCreate();
	return (
		<FormBuilder
			data={data}
			mode='create'
			showLoader={showLoader}
			validationSchema={validationSchema}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			setShowLoader={setShowLoader}
			fieldConfig={FORM_FIELD_CONFIG}
			layoutConfig={FORM_LAYOUT_CONFIG}
		/>
	);
};

export default CreatePermissions;
